import { useEffect } from "react";
import { useAuthStore } from "../contexts/AuthContext";
import { useAccountDispatch } from "../contexts/AccountContext";
import { useState } from "react";
import { useUserDispatch } from "../contexts/UserContext";

export default function useGetAccounts() {
    const accountDispatch = useAccountDispatch();
    const { selectedAccount } = useAuthStore();
    
    useEffect(()=>{
        accountDispatch({type: 'setIsLoadingAccounts', payload: true});

        //  for super admins with "Innovare" selected as the account (no id), return all accounts
        let url = selectedAccount.id? `/api/accounts?account=${selectedAccount.id}`: '/api/accounts';

        fetch(url)
        .then(r=>r.json())
        .then(data=>{
            accountDispatch({type: 'setAccounts', payload: data});
            accountDispatch({type: 'setIsLoadingAccounts', payload: false});
        })
    },[
        selectedAccount,
        accountDispatch
    ])
};

export function useCreateAccount() {
    const accountDispatch = useAccountDispatch();
    const userDispatch = useUserDispatch();
    
    async function createAccount(payload) {
        const response = await fetch(`/api/accounts`, {
            method: "POST", 
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        })
        if (!response.ok) {
          const errPayload = await response.json()
          accountDispatch({type: 'createAccountError', payload: errPayload})
          return errPayload
        }
        if (response.ok) {
            const data = await response.json()
            accountDispatch({type: 'addAccount', payload: data})
            accountDispatch({
              type: 'createAccountError', 
              payload: { existingUsers: false}
            })
            userDispatch({ type: "addUsers", payload: data});
            return data
        } 
    }

    return {createAccount}
}

// PAYLOAD=> {id: REQUIRED, name, type, settingIds}
//we do not need to change the slug and owner's email
export function useEditAccount(payload) {
    const accountDispatch = useAccountDispatch();
    const [accountObj, setAccountObj] = useState(payload)
    
    async function editAccount() {
        const response = await fetch(`/api/accounts/${payload.id}`, {
            method: "PUT", 
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            
            body: JSON.stringify(accountObj)
        })
        if (response.ok) {
            const data = await response.json()
            accountDispatch({type: 'editAccount', payload: data})
            return data
        }else{
            const data = await response.json() //return the error msg
            return data
        }
    }

    return { accountObj, setAccountObj, editAccount}
}
